var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Uploader',{attrs:{"name":"file","multiple":"","max-count":_vm.item.num,"before-read":_vm.beforeUpload,"after-read":_vm.handleUploadChange,"file-list":_vm.defaultFileList},on:{"delete":_vm.removeObj}},[(_vm.item.style)?_c('div',{staticClass:"img"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }